import { createFileRoute } from '@tanstack/react-router';

import { ForgotPasswordPage } from '@/features/auth/ForgotPasswordPage';

/** Password recovery: anonymous, no search params; the address travels in session storage. */
export const Route = createFileRoute('/forgot-password')({
    component: ForgotPasswordPage,
});
